import { render } from "./PaymentPageSettings.vue?vue&type=template&id=430e3252&ts=true"
import script from "./PaymentPageSettings.vue?vue&type=script&lang=ts"
export * from "./PaymentPageSettings.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__